import * as React from "react";

function SvgPhoto(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <defs>
        <clipPath id="photo_svg__prefix__clip-path">
          <path
            id="photo_svg__prefix__Ret\xE2ngulo_318"
            d="M0 0h20v20H0z"
            className="photo_svg__prefix__cls-1"
            data-name="Ret\xE2ngulo 318"
          />
        </clipPath>
        <style>{".photo_svg__prefix__cls-1{fill:#fff;stroke:#fff}"}</style>
      </defs>
      <g
        id="photo_svg__prefix__Grupo_de_m\xE1scara_53"
        data-name="Grupo de m\xE1scara 53"
      >
        <g id="photo_svg__prefix__photo-camera" transform="translate(1 3)">
          <g id="photo_svg__prefix__Grupo_446" data-name="Grupo 446">
            <path
              id="photo_svg__prefix__Caminho_135"
              d="M0 6.168v7.611a2.154 2.154 0 002.2 2.105h13.6a2.154 2.154 0 002.2-2.105V6.168a2.049 2.049 0 00-2.09-2h-2.924l-.07-.292A2.649 2.649 0 0010.3 1.884H7.7a2.655 2.655 0 00-2.62 1.989l-.07.292H2.09A2.051 2.051 0 000 6.168zm5.371-1.141a.444.444 0 00.437-.334l.151-.627A1.763 1.763 0 017.7 2.746h2.6a1.763 1.763 0 011.738 1.32l.151.627a.448.448 0 00.437.334h3.28A1.166 1.166 0 0117.1 6.168v7.611a1.27 1.27 0 01-1.3 1.243H2.2a1.27 1.27 0 01-1.3-1.243V6.168a1.166 1.166 0 011.19-1.141h3.28z"
              className="photo_svg__prefix__cls-1"
              data-name="Caminho 135"
              transform="translate(0 -1.884)"
            />
            <path
              id="photo_svg__prefix__Caminho_136"
              d="M9.55 14.649A3.75 3.75 0 105.8 10.9a3.756 3.756 0 003.75 3.749zm0-6.607A2.857 2.857 0 116.693 10.9 2.862 2.862 0 019.55 8.042z"
              className="photo_svg__prefix__cls-1"
              data-name="Caminho 136"
              transform="translate(-.5 -3.149)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgPhoto;

